import type {CreateExtArgs, Extension} from '@wix/document-manager-core'
import type {AccessibilityExtensionAPI} from './types'
import {createVisualFocusAPI} from './visualFocus'
import {createAutoDomReorderAPI} from './autoDomReorder'
import {createSkipToContentAPI} from './skipToContent'
import {createLanguageDirectionAPI} from './languageDirection'

const createExtension = (): Extension => {
    const createExtensionAPI = (createExtArgs: CreateExtArgs): AccessibilityExtensionAPI => {
        const visualFocusAPI = createVisualFocusAPI(createExtArgs)
        const autoDomReorderAPI = createAutoDomReorderAPI(createExtArgs)
        const skipToContentAPI = createSkipToContentAPI(createExtArgs)
        const languageDirectionAPI = createLanguageDirectionAPI(createExtArgs)

        return {
            accessibility: {
                visualFocus: visualFocusAPI,
                autoDomReorder: autoDomReorderAPI,
                skipToContent: skipToContentAPI,
                languageDirection: languageDirectionAPI
            }
        } as AccessibilityExtensionAPI
    }

    return {
        name: 'accessibility',
        createExtensionAPI
    }
}

export {createExtension}
